module.exports = __webpack_public_path__ + "static/DSC_9373-ebeeace18018bbaa63c0509e95414774.jpg";